import { ISelectOption } from '@/components/form/fields/SelectField';

export const accessOptions: ISelectOption[] = [
  { label: 'Viewer', value: 'VIEWER' },
  { label: 'Fullaccess', value: 'FULL_ACCESS' },
];
